import { ScrollArea } from "@base-ui/react/scroll-area"
import React from "react"

import { ProductConfiguratorConfigurationForm } from "./ProductConfiguratorConfigurationForm"

export const ProductConfiguratorConfiguration = React.memo(() => (
  <ScrollArea.Root className="scroll-area scroll-area--vertical shadow-s product-configuration-step">
    <ScrollArea.Viewport className="scroll-area__viewport">
      <ScrollArea.Content className="scroll-area__content product-configuration-step__content">
        <ProductConfiguratorConfigurationForm />
      </ScrollArea.Content>
    </ScrollArea.Viewport>
    <ScrollArea.Scrollbar
      orientation="vertical"
      className="scroll-area__scrollbar"
    >
      <ScrollArea.Thumb className="scroll-area__thumb" />
    </ScrollArea.Scrollbar>
  </ScrollArea.Root>
))
